import { render, staticRenderFns } from "./InternetOffers.vue?vue&type=template&id=a28e729c&scoped=true&"
import script from "./InternetOffers.vue?vue&type=script&lang=js&"
export * from "./InternetOffers.vue?vue&type=script&lang=js&"
import style0 from "./InternetOffers.vue?vue&type=style&index=0&id=a28e729c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28e729c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a28e729c')) {
      api.createRecord('a28e729c', component.options)
    } else {
      api.reload('a28e729c', component.options)
    }
    module.hot.accept("./InternetOffers.vue?vue&type=template&id=a28e729c&scoped=true&", function () {
      api.rerender('a28e729c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/orange/broadband/demands/showcase/internetandmobileoffers/components/InternetOffers.vue"
export default component.exports